export default {
  ADD_USER_TRAININGS (state, userTrainings) {
    state.userTrainings = [...state.userTrainings, ...userTrainings]
  },
  START_TRAINING (state, uuid) {
  }
}
